import { Map } from "ol";
import { Coordinate } from "ol/coordinate";
import { GeometryHelpers } from "./geometryhelpers";
import UserEventInfo from "./UserEventInfo";

export interface GridPointInfo {
    coords: Coordinate;
    isOnGrid: boolean;
}

export default class GridPointHelper {
    static querySnap(map: Map, userEvent: UserEventInfo, gridCoords: Coordinate): GridPointInfo {
        const pixelOfGridCoords = map.getPixelFromCoordinate(gridCoords)
        if(GeometryHelpers.isCloseEnoughToSnapToRoad(userEvent.pixel, pixelOfGridCoords)) {
            return {
                isOnGrid: true,
                coords: gridCoords
            }
        } else {
            return {
                isOnGrid: false,
                coords: userEvent.coordinate
            }
        }
    }
}